<template>
  <q-form ref="editForm">
    <c-card class="cardClassDetailInfo" :noHeader="true">
      <template slot="card-detail">
        <div class="col-3">
          <c-label-text title="감사명" :value="info.col1"></c-label-text>
        </div>
        <div class="col-3">
          <c-label-text title="감사년도" :value="info.col2"></c-label-text>
        </div>
        <div class="col-3">
          <c-label-text title="감사종류" :value="info.col3"></c-label-text>
        </div>
        <div class="col-3">
          <c-label-text title="사업장" :value="info.col4"></c-label-text>
        </div>
      </template>
    </c-card>
    <c-card title="감사실행정보" class="cardClassDetailForm" topClass="topcolor-lightblue">
      <template slot="card-button">
        <q-btn-group outline >
          <c-btn v-if="editable && !param.disabled" label="감사완료" icon="assignment_turned_in" color="red" />
          <c-btn v-if="editable && !param.disabled" label="임시저장" icon="save" />
        </q-btn-group>
      </template>
      <template slot="card-detail">
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
          <c-textarea
            :editable="editable"
            :disabled="param.disabled"
            label="감사원 소견"
            name="col1"
            v-model="hazopPlan.col1">
          </c-textarea>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
          <c-textarea
            :editable="editable"
            :disabled="param.disabled"
            label="감사 결과 종합의견"
            name="col2"
            v-model="hazopPlan.col2">
          </c-textarea>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-table
            topBorderClass="topcolor-lightblue"
            ref="grid1"
            title="감사대상"
            tableId="grid1"
            :columnSetting="false"
            :isFullScreen="false"
            :usePaging="false"
            :filtering="false"
            :hideBottom="true"
            :columns="grid1.columns"
            :data="grid1.data"
            @rowClick="rowClick"
          >
          </c-table>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-9 col-lg-9 col-xl-9">
          <c-textarea
            :editable="editable"
            :disabled="param.disabled"
            label="시정 및 권고 요약"
            name="col3"
            v-model="hazopPlan.col3">
          </c-textarea>
          <c-table
            topBorderClass="topcolor-lightblue"
            ref="grid2"
            title="감사항목"
            tableId="grid2"
            :columnSetting="false"
            :isFullScreen="false"
            :usePaging="false"
            :filtering="false"
            :hideBottom="true"
            :columns="grid2.columns"
            :data="grid2.data"
            selection="multiple"
            rowKey="col1"
          >
            <template slot="table-button">
              <div>
                <q-btn-group>
                  <c-btn label="개선요청" icon="save" />
                </q-btn-group>
              </div>
            </template>
          </c-table>
        </div>
      </template>
    </c-card>
  </q-form>
</template>

<script>
export default {
  name: 'hazop-plan-info',
  props: {
    param: {
      type: Object,
      default: () => ({
        disabled: false,
      }),
    },
  },
  data() {
    return {
      grid1: {
        columns: [
          {
            name: 'col1',
            field: 'col1',
            label: '평가기준항목',
            align: 'left',
            sortable: false,
          },
        ],
        data: [],
      },
      grid2: {
        columns: [
          {
            name: 'col1',
            field: 'col1',
            label: '감사항목',
            align: 'left',
            style: 'width: 50%',
            type: 'html',
            sortable: false,
          },
          {
            name: 'col2',
            field: 'col2',
            label: '감사결과',
            align: 'left',
            type: 'textarea',
            sortable: false,
          },
          {
            name: 'col3',
            field: 'col3',
            valueName: 'col3',
            label: '평가',
            align: 'center',
            style: 'width: 80px',
            sortable: false,
            type: 'select',
            comboItems: [
              { code: '10', codeName: 'A' },
              { code: '8', codeName: 'B' },
              { code: '6', codeName: 'C' },
              { code: '4', codeName: 'D' },
              { code: '2', codeName: 'E' },
            ],
          },
          {
            name: 'col3',
            field: 'col3',
            label: '배점',
            style: 'width: 50px',
            align: 'right',
            sortable: false,
          },
          {
            name: 'col5',
            field: 'col5',
            label: '시정 및 권고',
            align: 'left',
            type: 'textarea',
            sortable: false,
          },
        ],
        data: [],
      },
      info: {
        col1: '정기 자체감사',
        col2: '2021년',
        col3: '정기자체감사',
        col4: '사업장1',
      },
      hazopPlan: {
        col1: '',
        col2: '',
        col3: '',
      },
      attItems: [
        { code: '1', codeName: '정기' },
        { code: '2', codeName: '수시' },
      ],
      matrixItems: [
        { matrixNo: 1, matrixNm: 'hazop-1' },
        { matrixNo: 2, matrixNm: 'hazop-2' },
      ],
      editable: true,
      searchUrl: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      // url setting
      // code setting
      // list setting
      this.hazopPlan = {
        plantCd: '3',
        request: '안전환경팀/시스템/2021-01-01',
        period: ['2021-01-01', '2021-06-30'],
        year: '2021',
        att: '1',
        matrixNo: 1,
        userId: '1',
        deptCd: '',
        col1: '정기 hazop 평가',
        col3: 'XXXX 평가 상세내용',
      };
      this.getList();
    },
    getList() {
      this.grid1.data = [
        {
          col1: '안전경영과 근로자참여',
          col2: '1',
        },
        {
          col1: '공정안전자료',
          col2: '2',
        },
        {
          col1: '공정위험성평가',
          col2: '3',
        },
        {
          col1: '안전운전 지침과 절차',
          col2: '4',
        },
        {
          col1: '설비의 점검 검사 보수계획, 유지계획 및 지침',
          col2: '5',
        },
        {
          col1: '안전작업허가 및 절차',
          col2: '6',
        },
        {
          col1: '도급업체 안전관리',
          col2: '7',
        },
        {
          col1: '공정운전에 대한 교육훈련',
          col2: '8',
        },
        {
          col1: '가동전 점검지침',
          col2: '9',
        },
        {
          col1: '변경요소 관리계획',
          col2: '10',
        },
        {
          col1: '자체감사',
          col2: '11',
        },
        {
          col1: '안전사고조사 지침',
          col2: '12',
        },
        {
          col1: '비상조치계획',
          col2: '13',
        },
        {
          col1: '현장확인',
          col2: '14',
        },
      ]
    },
    rowClick(row) {
      if (row.col2 == '1') {
        this.grid2.data = [
          {col1: '14-01 회사의 경영목표로 안전·보건을 우선적으로 강조하고 실천하는가? '},
          {col1: '14-02 공정안전관리(PSM) 12개 요소의 내용과 목적을 정확하게 이해하고 있는가?'},
          {col1: '14-03 공정위험성평가, 변경요소관리, 안전사고 및 자체감사 결과의 개선권고사항 및 처리현황을 정기적으로 확인하고 있는가?'},
          {col1: '14-04 사업장 내·외부 PSM 관련 안전·보건 교육훈련계획을 승인하고 그 결과를 보고 받는가?'},
          {col1: '14-04 사업장 내·외부 PSM 관련 안전·보건 교육훈련계획을 승인하고 그 결과를 보고 받는가?'},
        ]
      } else if (row.col2 == '2') {
        this.grid2.data = [
          {col1: '1-01 사업장에서 사용하고 있는 유해위험물질의 목록이 누락된 물질 없이 정확히 작성되어 있는가?'},
          {col1: '1-02 사업장에서 사용하고 있는 유해·위험물질에 대한 물질안전보건자료(MSDS)의 작성, 비치, 교육, 경고표지 등이 적절하게 되었는가?'},
          {col1: '1-03 유해·위험설비 및 목록(동력기계, 장치 및 설비, 배관, 안전밸브 등)이 정확히 작성되어 있으며 현장과 일치하는가?'},
          {col1: '1-04 공정흐름도(PFD), 공정배관계장도(P&ID), 유틸리티흐름도(UFD)가 정확히 작성되어 있으며 현장과 일치하는가?'},
          {col1: '1-05 건물·설비의 배치도(가스누출감지경보기 설치계획, 국소배기장치 설치계획 등)가 정확히 작성되어 있으며 현장과 일치하는가?'},
        ]
      } else {
        this.grid2.data = [];
      }
    },
  }
};
</script>
